<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :allowFields="$lang.searchIndicatorFildes"
      :url="url"
      :hiddenFields="hiddenFields"
      :title="$lang.searchIndicator"
      :remove_item="remove_item"
      addModalSize="lg"
      removeModalSize="xl"
      :toggleable="true"
      :dynamicButtons="buttons"
      ref="searchIndicator"
      :isImportExcel="true"
      :isImportExcelTooltip="$lang.all_indicator_sample_download_tooltiop"
      @importExcel="showImportExcelModal"
      @showCompetencyCount="showCompetencyCount"
    >
      <template slot="headerButtonsLast">
        <b-button
          class="ml-2 btn-lightgray"
          v-b-tooltip.hover
          :title="$lang.marge_indicator"
          @click="openMargeModal"
        >
          <i class="fa fa-object-ungroup" aria-hidden="true"></i>
        </b-button>
      </template>
      <template slot="addModal" slot-scope="search">
        <AddIndicator
          isModal
          @modal-end-up="search.close"
          @getItems="getItems"
        />
      </template>
    </Search>
    <b-modal
      no-close-on-backdrop
      hide-header
      hide-footer
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      size="lg"
      v-model="importExcelModal"
    >
      <b-card>
        <div slot="header">
          {{ $lang.all_indicator_upload_excel_form_title }}
        </div>
        <ShowCardUpload
          :url="uploadExcelUrl"
          :showAlert="exampleFileLink"
          @getItems="getItems"
          @closeModal="showImportExcelModal(false)"
        />
      </b-card>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_competency_indicator"
      size="xl"
      hide-header
      ok-only
    >
      <DragTable
        :showCheckbox="false"
        :title="$lang.related_competency"
        :url="competency_indicator_url"
        ref="competency_indicator"
        :dynamicButtons="buttonsCompetencyIndicator"
        :permissionButtons="permissionButtons"
        :keyLang="`competencyIndicatorFields`"
        :hasMoving="false"
        :editRoute="false"
        :removeLabel="$lang.exercise_remove"
      />
      <template v-slot:modal-footer>
        <b-button variant="danger" @click="closeCompetencyIndicator">
          {{ $lang.close }}
          <i class="fa fa-ban"></i>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      no-close-on-backdrop
      variant="primary"
      header-bg-variant="primary"
      content-class="border-primary"
      v-model="view_marge_indicator"
      size="xl"
      hide-header
      hide-footer
      ok-only
    >
      <b-alert show dismissible>
        {{ $lang.warnig_marge_indicators }}
      </b-alert>
      <div class="text-center" v-if="isMargeLoader">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <b-form @submit.prevent="putMargeIndicator" v-if="!isMargeLoader">
        <b-row>
          <b-col xs="12" md="12">
            <b-form-group
              :label="$lang.refrence_indicator"
              label-for="refrence_indicator_selected"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.refrence_indicator"
                :rules="$v.refrence_indicator_selected.$params"
              />
              <selectFind
                :options="indicator_options"
                v-model="$v.refrence_indicator_selected.$model"
                label="text"
                :isValid="
                  $v.refrence_indicator_selected.$dirty
                    ? !$v.refrence_indicator_selected.$error
                    : null
                "
                :loading="refrenceIndicatorLoading"
              />

              <b-form-invalid-feedback
                id="refrence_indicator_selected-feedback"
                :style="{
                  display: $v.refrence_indicator_selected.$error
                    ? 'block'
                    : 'none',
                }"
              >
                {{
                  $lang.error_required | replace($lang.refrence_indicator)
                }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col xs="12" md="12">
            <b-form-group
              :label="$lang.indicator_selected_marger"
              label-for="indicator_marger_selected"
              :label-cols="this.$config.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.indicator_selected_marger"
                :rules="$v.indicator_marger_selected.$params"
              />
              <selectFind
                :options="indicator_options"
                v-model="$v.indicator_marger_selected.$model"
                label="text"
                :isValid="
                  $v.indicator_marger_selected.$dirty
                    ? !$v.indicator_marger_selected.$error
                    : null
                "
                :loading="refrenceIndicatorLoading"
              />
              <b-form-invalid-feedback
                id="indicator_marger_selected-feedback"
                :style="{
                  display: $v.indicator_marger_selected.$error
                    ? 'block'
                    : 'none',
                }"
              >
                {{
                  $lang.error_required
                    | replace($lang.indicator_selected_marger)
                }}</b-form-invalid-feedback
              >
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" class="float-right">
            <div slot="footer" class="form-group form-btn">
              <b-button type="submit" size="md" variant="success">
                <i class="fa fa-check"></i>
                {{ $lang.submitButton }}
              </b-button>
              <b-button
                type="reset"
                class="ml-2"
                size="md"
                variant="danger"
                @click="view_marge_indicator = false"
              >
                <i class="fa fa-ban"></i>
                {{ $lang.cancelButton }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <Confirm
      v-model="enableConfirm"
      :title="$lang.change_indicator_state"
      :description="enableConfirmDescription"
      dynamicClass=""
      :loading="enableConfirmLoading"
      :loadingSpinnerText="$lang.updating_data"
      :preventDefault="true"
      :cancel-title="$lang.no"
      :ok-title="$lang.yes"
      @cancel="cancelEnableConfirm"
      @ok="okEnableConfirm"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddIndicator from "./addIndicator";
import ShowCardUpload from "@/components/fileManager/showCardUpload";
import DragTable from "@/components/base/dragTable";
import Confirm from "@/components/base/confirm";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateApiUrl, goToRoute } from "@/shared/utils";

export default {
  name: "search-indicator",
  components: {
    Search,
    AddIndicator,
    DragTable,
    Confirm,
    ShowCardUpload,
  },
  validations: {
    refrence_indicator_selected: {
      required,
    },
    indicator_marger_selected: {
      required,
    },
  },
  data() {
    return {
      isMargeLoader: false,
      indicator_options: [],
      indicator_marger_selected: null,
      refrenceIndicatorLoading: false,
      refrence_indicator_selected: null,
      view_marge_indicator: false,
      hiddenFields: [
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at",
        "caption_second_person",
        "caption_imperative",
        "caption_managerial",
        "caption_third_person",
      ],
      loadingItem: false,
      permissionButtons: [],
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "1",
          name: "design",
          click: this.competencyDesign,
        },
        {
          id: "2",
          name: "enable",
          click: this.showEnableConfirm,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      competency_indicator_url: null,
      view_competency_indicator: false,
      buttonsCompetencyIndicator: [
        {
          id: "3",
          name: "delete",
          click: this.deleteCompetencyIndicator,
        },
      ],
      enableConfirm: false,
      enableConfirmLoading: false,
      enableConfirmItem: null,
      importExcelModal: false,
    };
  },
  computed: {
    enableConfirmDescription() {
      const is_enable = pathOr(null, ["is_enable"], this.enableConfirmItem);
      return is_enable
        ? `با غیر فعال سازی این نشانگر، دیگر قابل انتخاب و اتصال جدید به شایستگی نمی باشد ولی ارتباطات قبلی قابل استفاده می باشد.
      <br><br><strong>آیا از غیر فعال سازی نشانگر اطمینان دارید؟</strong>`
        : `با فعال سازی این نشانگر، نشانگر قابل انتخاب و اتصال جدید به شایستگی می باشد.
      <br><br><strong>آیا از فعال نشانگر شایستگی اطمینان دارید؟</strong>`;
    },
    url() {
      return generateApiUrl(["kanoon", "indicator"]);
    },
    uploadExcelUrl() {
      return generateApiUrl(["kanoon", "import_indicator"]);
    },
    exampleFileLink() {
      const link = `${generateApiUrl(["resources", "upload_folder"], [], {}, [
        "server_url",
      ])}/import_indicator.xlsx`;
      return `<div class='text-center font-weight-bold'><a href='${link}'>جهت دانلود فایل نمونه کلیک کنید</a></div>`;
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    goToRoute,
    openMargeModal() {
      this.view_marge_indicator = true;
      this.getIndicators();
    },
    async deleteCompetencyIndicator(item) {
      try {
        let url =
          this.$config.api_url +
          this.$config.kanoon.competency_indicator.replace(
            "{0}",
            item.competency && item.competency.id
          ) +
          `/${item.indicator && item.indicator.id}`;
        let response = await this.$httpService.delete(url);
        this.view_competency_indicator = false;
        this.$notify.success(response.data.message);
        this.fetchData();
      } catch (error) {
        this.$generateError(error);
      }
    },
    showCompetencyCount(item) {
      const exercise_count = pathOr(0, ["competency_count"], item);
      if (!exercise_count)
        return this.$notify.warning("داده ای برای نمایش وجود ندارد");

      this.permissionButtons = this.$refs.searchIndicator.permission;
      this.view_competency_indicator = true;
      let params = "indicator_id=" + item.id;
      this.competency_indicator_url =
        this.$config.api_url +
        this.$config.kanoon.competency_indicator_filter +
        `?${params}`;
    },
    closeCompetencyIndicator() {
      this.view_competency_indicator = false;
    },
    competencyDesign(item) {
      const id = pathOr(null, ["id"], item);
      const name = "indicator-evidence";
      const params = { id };
      goToRoute(name, params, {}, false);
    },
    getItems() {
      this.$refs.searchIndicator.getItems();
    },
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    async getIndicators() {
      try {
        this.refrenceIndicatorLoading = true;
        let url =
          this.$config.api_url + this.$config.kanoon.indicator + "/combo";
        const response = await this.$httpService.get(url);
        let data = response.data.data;
        this.indicator_options = data.map((x) => {
          return {
            text: x.caption,
            value: x.id,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.refrenceIndicatorLoading = false;
      }
    },
    async putMargeIndicator() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      let refrence_indicator =
        this.refrence_indicator_selected &&
        this.refrence_indicator_selected.value;
      let indicator_marger =
        this.indicator_marger_selected && this.indicator_marger_selected.value;

      if (refrence_indicator !== indicator_marger) {
        this.isMargeLoader = true;
        try {
          let payload = {
            reference_id: refrence_indicator,
          };
          let url =
            this.$config.api_url +
            this.$config.kanoon.indicator_merge.replace(
              "{0}",
              indicator_marger
            );
          const response = await this.$httpService.put(url, payload);
          this.$notify.success(response.data.message);
          this.view_marge_indicator = false;
          this.$v.$reset();
          this.$refs.searchIndicator.getItems();
        } catch (error) {
          this.$generateError(error);
        } finally {
          this.isMargeLoader = false;
          this.refrence_indicator_selected = null;
          this.indicator_marger_selected = null;
        }
      } else {
        this.$notify.error(this.$lang.error_marge_indicator);
      }
    },
    showEnableConfirm(item) {
      this.enableConfirmItem = item;
      this.enableConfirm = true;
    },
    cancelEnableConfirm() {
      this.enableConfirmItem = null;
      this.enableConfirm = false;
    },
    async okEnableConfirm() {
      try {
        this.enableConfirmLoading = true;
        const { id, is_enable } = this.enableConfirmItem;
        const url = generateApiUrl(["kanoon", "indicator_id"], [id]);
        const payload = { is_enable: is_enable ? 0 : 1 };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.cancelEnableConfirm();
        this.getItems();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.enableConfirmLoading = false;
      }
    },
    showImportExcelModal(state = true) {
      this.importExcelModal = state;
    },
  },
};
</script>

<style>
</style>
